export const testEvents = [
  {
    id: 1,
    eventMembers: [
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 1",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
    ],
  },
  {
    id: 2,
    eventMembers: [
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 2",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
    ],
  },
  {
    id: 3,
    eventMembers: [
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 3",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 3",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 3",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 3",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 3",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 3",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 3",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 3",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "THIS IS EVENT 3",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "345345",
        name: "Mary Barry",
        tempAccount: false,
        dateAdded: "11/30/2022 22:55:01",
        attended: false,
      },
      {
        iboNumber: "3242344",
        name: "Jimbo Him",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: true,
      },
      {
        iboNumber: "635345435",
        name: "Gary Larry",
        tempAccount: false,
        dateAdded: "09/10/2020 22:55:01",
        attended: false,
      },
      {
        iboNumber: "12345",
        name: "This is a very very very very very long name",
        tempAccount: true,
        dateAdded: "11/29/2022 22:55:01",
        attended: false,
      },
    ],
  },
];

export default testEvents;
